/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:56699bb9-b252-4e78-85a7-32182e2e24eb",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_pWgWAZzft",
    "aws_user_pools_web_client_id": "3nm3eeftjd08n21u5bt2930sac",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://bqzzvv4cibdcxnfukq54d65m6i.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
